import React, { useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import styled from 'styled-components'
import {
  ListSubheader,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Divider,
} from '@material-ui/core'
import StarBorder from '@material-ui/icons/StarBorder'
import MenuCollapse from './MenuWidgets/MenuCollapse.js'
import Icons from './Icons'
import LeagueIcon from './InplayWidgets/TeamImage.js'

const MenuListSubheader = styled(ListSubheader)`
  padding-left: ${props => props.theme.spacing(6)}px;
  padding-right: ${props => props.theme.spacing(6)}px;
`

const MenuListItem = styled(ListItem)`
  padding-left: ${props => props.theme.spacing(6)}px;
  padding-right: ${props => props.theme.spacing(6)}px;
`
const MenuListItemIcon = styled(ListItemIcon)`
  min-width: 40px;
`
const MenuListItemText = styled(ListItemText)`
  padding-left: 0;
`

const DividerFullWidth = styled(Divider)`
  margin: ${props => props.theme.spacing(2)}px 0;
`
const CompetitionLogo = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${props => props.theme.palette.background.default};
  margin-left: -${props => props.theme.spacing(0.5)}px;
  margin-right: ${props => props.theme.spacing(2)}px;
  padding: ${props => props.theme.spacing(1.5)}px;
  border-radius: 50%;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
`

const MenuList = props => {
  const { items } = props
  /* Unique list of sports */
  const sports = _.uniq(Object.keys(items).map(key => items[key].node.sport))

  const [state, setState] = useState({
    open: true,
  })

  return (
    <List
      component="nav"
      subheader={
        <MenuListSubheader component="div" color="default" disableSticky>
          <Box
            fontWeight="fontWeightBold"
            fontSize="body1.fontSize"
            style={{ textTransform: `uppercase` }}
          >
            Popular
          </Box>
        </MenuListSubheader>
      }
    >
      <MenuListItem button component={Link} to="/soccer/mls">
        <CompetitionLogo>
          <LeagueIcon teamname="mls" />
        </CompetitionLogo>
        <MenuListItemText inset primary="MLS" />
      </MenuListItem>
      <MenuListItem button component={Link} to="/basketball/nba">
        <CompetitionLogo>
          <LeagueIcon teamname="nba" />
        </CompetitionLogo>
        <MenuListItemText inset primary="NBA" />
      </MenuListItem>
      <MenuListItem button component={Link} to="/american-football/nfl">
        <CompetitionLogo>
          <LeagueIcon teamname="nfl" />
        </CompetitionLogo>
        <MenuListItemText inset primary="NFL" />
      </MenuListItem>
      <DividerFullWidth />
      <MenuCollapse
        title="A-Z Sports"
        key={sports.length}
        stateIn={state.open}
        timeout="auto"
        unmountOnExit
      >
        {Object.keys(sports).map(key => (
          <List component="div" key={sports[key]} disablePadding>
            <MenuListItem
              button
              component={Link}
              to={`/${_.kebabCase(sports[key])}`}
            >
              <MenuListItemIcon>
                <Icons
                  icon={sports[key]}
                  style={{
                    fontSize: 24,
                    marginTop: '-4px',
                    marginBottom: '1px',
                  }}
                />
              </MenuListItemIcon>
              <MenuListItemText
                inset
                primary={sports[key]}
                style={{ textTransform: 'capitalize' }}
              />
            </MenuListItem>
          </List>
        ))}
      </MenuCollapse>
    </List>
  )
}

MenuList.propTypes = {
  items: PropTypes.array,
}

export default MenuList
